import { Modal, Row, Col } from "react-bootstrap";
import ButtonCommon from "./ButtonCommon";
import "./ModalActionMessage.css";

const ModalActionMessage = (props: any) => {
  const onHandleClose = () => {
    if (props.OnModalClose) props.OnModalClose();
  };

  const onHandleOk = () => {
    if (props.OnModalOk) props.OnModalOk();
  };

  return (
    <>
      <Modal show={props.Show} onHide={() => onHandleClose()} centered>
        <Modal.Header closeButton className="border-bottom-0">
          {/* <Modal.Title className="font-modal-header">
                        {props.Title || 'Titulo Modal'}
                    </Modal.Title> */}
        </Modal.Header>
        <Modal.Body>
          <Row className="justify-content-center">
            <Col xs={11} className={`text-center`}>
              <img src={"img/icon-save-success.png"} width={274} />
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col xs={11}>
              <p className="font-modal-message-action">
                {props.Title || "Titulo Modal"}
              </p>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalActionMessage;
